import { 
  SET_SIGNALR_CONNECTION_CONTEST,
  SIGNALR_CONTEST_CONNECTED,
  SIGNALR_CONTEST_DISCONNECTED,
  FETCH_AUTH_TOKEN,
  RECEIVE_AUTH_TOKEN
} from './constants';
import { CFAuthPostRef } from 'auth';
import { locations } from '../../common/redux/action_locations';

export const setSignalRConnectionContestAction = () => {
  return {
    type: SET_SIGNALR_CONNECTION_CONTEST
  };
}

export const signalRConnectedAction = () => {
  return {
    type: SIGNALR_CONTEST_CONNECTED
  }
}

export const signalRDisconnectedAction = () => {
  return {
    type: SIGNALR_CONTEST_DISCONNECTED
  }
}

export const receivedAuthToken = (tokenData) => {
  // Received action reducer in signalRMiddlewareContests.js
  return {
    type: RECEIVE_AUTH_TOKEN,
    authToken: tokenData.data.authtoken
  }
}

export const fetchAuthToken = (filters) => {
	return {
    type: FETCH_AUTH_TOKEN,
    fetchCall: fetchAuthTokenCall,
    receivedAction: receivedAuthToken,
    data: { locations, filters }
  }
}

export const fetchAuthTokenCall = () => {
	return CFAuthPostRef({
    url: locations.tokenUrl,
    body: {
      RefreshToken: localStorage.REFRESH_TOKEN
    },
    originURL: locations.originUrl,
    loaderName: ''
});
}

export const reducer = (state, { type, token }) => {
  switch(type) {
    case SIGNALR_CONTEST_CONNECTED:
      return {
        ...state,
        signalRConnected: true,
      }
    case SIGNALR_CONTEST_DISCONNECTED:
      return {
        ...state,
        signalRConnected: false,
      }
    case SET_SIGNALR_CONNECTION_CONTEST:
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/contests/redux/setSignalRContestConnection.js